// Where ActionCable may subscribe (limits /cable WebSocket to these URLs only).

export function isPrincipalListingHomeCablePage() {
  if (typeof window === "undefined" || !window.location) return false
  const p = window.location.pathname || ""
  return p === "/" || p === ""
}

// Public auction ad page, e.g. /online-auction/helsinki/my-ad-title/123784
// The first segment is auction.ad_category, an I18n-translated string (see
// application_helper.rb), so it varies per locale (e.g. "nettihuutokauppa" in
// Finnish) — match on path shape only, not a hardcoded English slug.
export function isAuctionDetailCablePage() {
  if (typeof window === "undefined" || !window.location) return false
  const p = window.location.pathname || ""
  return /^\/[^/]+\/[^/]+\/[^/]+\/\d+$/.test(p)
}

export function isAdminOffersMultiAuctionCablePage() {
  if (typeof window === "undefined" || !window.location) return false
  const p = window.location.pathname || ""
  return p === "/admin/offers/open_active_bids" || p === "/admin/offers/check_own_wishlist"
}
